import { render, staticRenderFns } from "./Etapa4.vue?vue&type=template&id=0b684d5c&scoped=true"
import script from "./Etapa4.vue?vue&type=script&lang=js"
export * from "./Etapa4.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=0b684d5c&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa4.vue?vue&type=style&index=1&id=0b684d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b684d5c",
  null
  
)

export default component.exports